import SiteShell from "../components/SiteShell";

const policyLinks = [
  {
    title: "Privacy Policy",
    text: "How we collect, use, retain, and protect personal data.",
    href: "#/privacy-policy",
  },
  {
    title: "Cookies Policy",
    text: "How cookies and similar technologies are used on our platform.",
    href: "#/cookies-policy",
  },
  {
    title: "Grievance Policy",
    text: "How complaints are acknowledged, reviewed, and resolved.",
    href: "#/grievance-policy",
  },
  {
    title: "Terms and Conditions",
    text: "Rules and legal conditions for platform usage.",
    href: "#/terms-and-conditions",
  },
  {
    title: "Interest Rate Charges Policy",
    text: "How interest rates, risk-based pricing, and borrower disclosures are determined.",
    href: "#/interest-rate-policy",
  },
  {
    title: "Information Security Policy",
    text: "How information assets, controls, ISO 27001 alignment, and ISMS commitments are managed.",
    href: "#/info-policy",
  },
  {
    title: "KYC & AML Policy",
    text: "How customer identification, due diligence, reporting, and AML controls are managed.",
    href: "#/kyc-policy",
  },
  {
    title: "Media Policy",
    text: "How media interactions, spokesperson approvals, and filming requests are managed.",
    href: "#/media",
  },
  {
    title: "Social Media Policy",
    text: "How staff should use social platforms responsibly in official and personal contexts.",
    href: "#/social",
  },
  {
    title: "Risk Management Policy",
    text: "How the company identifies, assesses, reports, and mitigates key business risks.",
    href: "#/risk",
  },
  {
    title: "Refund & Cancellation Terms",
    text: "When an order can be cancelled, what happens after delivery confirmation, and who is responsible for product issues.",
    href: "#/refund-policy",
  },
];
const policyHighlights = [
  { label: "Processing Speed", value: "Real-time" },
  { label: "Target Audience", value: "Salaried" },
  { label: "Security Level", value: "Level 4" },
  { label: "Uptime Guaranteed", value: "99.99%" },
];

function Policies() {
  return (
    <SiteShell route="policies" heroHidden={true} highlightsHidden={true}>
      <section className="relative overflow-hidden bg-[#061a2e] pb-16 pt-24 text-white">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_0%_10%,rgba(223,31,45,0.3),transparent_35%),radial-gradient(circle_at_100%_90%,rgba(18,169,191,0.2),transparent_35%)]" />
        <div className="relative z-10 mx-auto max-w-[1280px] px-6 md:px-10">
          <p className="inline-flex rounded-full border border-white/20 bg-white/10 px-4 py-1 text-[10px] font-black uppercase tracking-[0.3em] text-sky-200">
            Policies
          </p>
          <h1 className="mt-7 text-4xl font-extrabold leading-tight tracking-tight md:text-6xl">
            Policy Center
          </h1>
          <p className="mt-6 max-w-3xl text-base leading-relaxed text-white/75 md:text-lg">
            Read our legal and compliance documents that define how Bharat
            Digital protects users and operates responsibly.
          </p>
        </div>
      </section>

      <section className="relative z-20 mx-auto -mt-8 max-w-[1280px] px-6 md:px-10">
        <div className="grid gap-4 rounded-3xl border border-slate-200 bg-white/80 p-4 shadow-[0_20px_50px_-12px_rgba(10,44,79,0.12)] backdrop-blur-2xl md:grid-cols-4 lg:p-6">
          {policyHighlights.map((item) => (
            <article
              key={item.label}
              className="group relative rounded-2xl bg-slate-50/50 p-6 transition-all hover:bg-white hover:shadow-xl"
            >
              <div className="absolute left-0 top-1/2 h-8 w-1 -translate-y-1/2 rounded-r-full bg-[#e37921] opacity-0 transition-opacity group-hover:opacity-100" />
              <p className="text-[15px] font-black uppercase tracking-[0.2em] text-[#e37921]/80">
                {item.label}
              </p>
              <h3 className="mt-2 text-xl font-extrabold tracking-tight text-[#0a2c4f]">
                {item.value}
              </h3>
            </article>
          ))}
        </div>
      </section>

      <section className="mx-auto mt-8 max-w-[1280px] px-6 pb-24 md:px-10">
        <div className="grid gap-4 rounded-3xl border border-slate-200 bg-white p-6 shadow-[0_20px_50px_-20px_rgba(0,0,0,0.18)] md:grid-cols-2 md:p-8">
          {policyLinks.map((item) => (
            <a
              key={item.title}
              href={item.href}
              className="rounded-2xl border border-slate-200 bg-slate-50 p-6 transition-all hover:-translate-y-1 hover:border-[#df1f2d]/30 hover:bg-white hover:shadow-lg"
            >
              <h2 className="text-xl font-bold tracking-tight text-[#111827]">
                {item.title}
              </h2>
              <p className="mt-3 text-sm leading-relaxed text-slate-600">
                {item.text}
              </p>
              <span className="mt-5 inline-flex text-xs font-black uppercase tracking-[0.14em] text-[#e37921]">
                Open policy
              </span>
            </a>
          ))}
        </div>
      </section>
    </SiteShell>
  );
}

export default Policies;
